import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface WishlistItem {
    id: number;
    product_id: number;
    product_name: string;
    product_image?: string;
    base_price: number;
    category_name?: string;
    added_at: string;
}

export interface WishlistState {
    items: WishlistItem[];
    
    // Actions
    addItem: (item: Omit<WishlistItem, 'added_at'>) => void;
    removeItem: (productId: number) => void;
    clearWishlist: () => void;
    hasItem: (productId: number) => boolean;
    getItemCount: () => number;
}

const useWishlistStore = create<WishlistState>()(
    persist(
        (set, get) => ({
            items: [],

            addItem: (newItem) => {
                const state = get();
                
                // Check if item already exists
                if (state.items.some(item => item.product_id === newItem.product_id)) {
                    return; // Item already in wishlist
                }
                
                const wishlistItem: WishlistItem = {
                    ...newItem,
                    added_at: new Date().toISOString(),
                };
                
                set({ items: [...state.items, wishlistItem] });
            },

            removeItem: (productId) => {
                const state = get();
                const updatedItems = state.items.filter(item => item.product_id !== productId);
                set({ items: updatedItems });
            },

            clearWishlist: () => {
                set({ items: [] });
            },

            hasItem: (productId) => {
                return get().items.some(item => item.product_id === productId);
            },

            getItemCount: () => {
                return get().items.length;
            },
        }),
        {
            name: "wishlist-storage",
        }
    )
);

export default useWishlistStore;
